import {Record} from 'immutable';
import User from 'records/User';
import moment from 'moment';

export default class RuleMatchInfo extends Record({
  description: undefined,
  fileUploadId: undefined,
  callLineOne: undefined,
  caller: undefined,
  matchDate: undefined,
}) {
  constructor(object = {}) {
    super({
      ...object,
      caller: new User(object.caller),
      matchDate: moment(object.matchDate),
    });
  }
}
